import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form';
import TagsInput from 'react-tagsinput'

import 'react-tagsinput/react-tagsinput.css'
import './UserSettings.css'

import settings_img from '../../assets/images/nav_icons/settings.svg'
import arrow_left from '../../assets/images/nav_icons/arrow-left.svg'
import trash_img from '../../assets/images/trash.svg'
import copy_img from '../../assets/images/copy.svg'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ContentCard from '../../components/_partials/ContentCard'
import { fetchUpdateProfileFields, fetchUpdateUsersAuthSettings, fetchUsersAuthSettings, fetchUsersFields } from './UsersApi';
import { toast } from 'react-toastify';
import { setLoading } from '../../services/global/globalSlice';
import ConfirmModal from '../../components/_modals/ConfirmModal';
import { DEFAULT_FIELDS } from '../../config/constants';
import { DraggableFieldCard, DraggableFields } from './DraggableFieldCard';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { loadUserFieldsData, selectUserData, updateUserOnboarding } from '../../features/User/userSlice';

import { useTour } from "@reactour/tour"
import { selectUserOnboarding } from "../../features/User/userSlice"
import { usersTourSteps } from "../../config/tour"


const FIED_TYPES = [
    {
        field_type: "text",
        field_id: "firstname",
        field_names: {
            it: "Nome",
            en: "Name"
        },
        field_level: 0,
        disabled: false,
    },
    {
        field_type: "text",
        field_id: "lastname",
        field_names: {
            it: "Cognome",
            en: "Surname"
        },
        field_level: 0,
        disabled: false,
    },
    {
        field_type: "text",
        field_id: "nickname",
        field_names: {
            it: "Nickname",
            en: "Nickname"
        },
        field_level: 0,
        disabled: false,
    },
    {
        field_type: "text",
        field_names: {
            it: "",
            en: ""
        },
        field_level: 0,
        disabled: false,
    },
    {
        field_type: "datetime",
        field_names: {
            it: "",
            en: ""
        },
        field_level: 0,
        disabled: false,
    },
    {
        field_type: "singular",
        field_names: {
            it: "",
            en: ""
        },
        field_level: 0,
        disabled: false,
        choices : []
    },
    {
        field_type: "multiple",
        field_names: {
            it: "",
            en: ""
        },
        field_level: 0,
        disabled: false,
        choices : []
    }
]

export default function UserSettingsScreen () {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [isUpdated, setIsUpdated] = useState(false)
    const [userAuthSettings, setUserAuthSettings] = useState({})
    const [userProfileFields, setUserProfileFields] = useState([])
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const dragEnded = (param) => {
        const { source, destination } = param;
        let _arr = [...userProfileFields];
        //extracting the source item from the list
        const _item = _arr.splice(source.index, 1)[0];
        //inserting it at the destination index.
        _arr.splice(destination.index, 0, _item);
        setUserProfileFields(_arr);
    };

    const loadUserAuthSettings = async () => {
        dispatch(setLoading(true))
        const response = await fetchUsersAuthSettings();
        if(response.success){
            setUserAuthSettings(response.data)
            dispatch(setLoading(false))
        } else {
            toast.error(t.error.error_loading)
            dispatch(setLoading(false))
        }
    }

    const loadUserProfileFields = async () => {
        dispatch(setLoading(true))
        const response = await fetchUsersFields();
        if(response.success){
            setUserProfileFields(response.data)
            dispatch(setLoading(false))
        } else {
            toast.error(t.error.error_loading)
            dispatch(setLoading(false))
        }
    }

    const handleSaveAuthSettings = async () => {
        dispatch(setLoading(true))
        const response = await fetchUpdateUsersAuthSettings(userAuthSettings);
        if(response.success){
            toast.success(t.users.settings.settings_updated)
            dispatch(setLoading(false))
        } else {
            toast.error(t.error.error_loading)
            dispatch(setLoading(false))
        }
    }

    const closeConfirmModal = () => {
        setConfirmModal({
            ...confirmModal,
            show: false
        })
    }

    const checkIsSaved = (e) => {
        if(isUpdated){
            setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.modals.exit_without_save,
                text: t.modals.exit_without_save_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>{navigate(location.state.from)},
                confirmCta: t.modals.exit,
                closeCta: t.modals.no_exit,
            })
            e.preventDefault();
        }
    }

    const addField = (f) => {
        setIsUpdated(true)
        if(f){
            f['is_open'] = true
            setUserProfileFields([...userProfileFields, f])
        } else {
            setUserProfileFields([...userProfileFields, {
                field_type: "text",
                field_names: {
                    it: "",
                    en: ""
                },
                field_level: 0,
                disabled: false,
                is_open: true
            }])
        }
    }

    const handleUpdateField = (value, index, key, subkey='') => {
        setIsUpdated(true)
        
        let currentFields = structuredClone(userProfileFields)
        if(['field_type', 'field_level', 'disabled', 'is_open', 'field_id'].includes(key)){
            currentFields[index][key] = value
        } else if (key === "field_names"){
            currentFields[index][key][subkey] = value
        } else if (key === "choices"){
            if(!currentFields[index][key])
                currentFields[index][key] = []
            if(subkey === "new")
                currentFields[index][key].push(value)  
            else if (subkey !== null && subkey !== undefined && subkey !== '')
                currentFields[index][key][subkey] = value
            else 
                currentFields[index][key] = value
        }
        console.log(currentFields);
        
        setUserProfileFields(currentFields)
    }

    const handleRemoveField = (index) => {
        let fields =structuredClone(userProfileFields);
        fields.splice(index, 1);
        setUserProfileFields(fields)
    }

    const handleDuplicateField = (field) => {
        let f = structuredClone(field)
        delete f.field_id
        setUserProfileFields([...userProfileFields, f])
    }

    const handleSaveProfileFields = async () => {
        dispatch(setLoading(true))

        const currentFields = structuredClone(userProfileFields)
        currentFields.every((f)=>{
            if(f.field_type === "singular" || f.field_type === "multiple"){
                if(f.choices?.length < 2){
                    toast.error(t.users.settings.fields.missing_answer)
                    return false;
                }
            }
            return true
        })
        
        const response = await fetchUpdateProfileFields(userProfileFields);
        if(response.success){
            toast.success(t.users.settings.settings_updated)
            dispatch(loadUserFieldsData())
            dispatch(setLoading(false))
        } else {
            toast.error(t.error.error_loading)
            dispatch(setLoading(false))
        }
    }

    useEffect(()=>{
        loadUserAuthSettings()
        loadUserProfileFields()
    },[])

    const userOnboarding  = useSelector(selectUserOnboarding)
    const userData = useSelector(selectUserData)
    const { setIsOpen, setCurrentStep, setSteps, setMeta } = useTour()
    
    useEffect(()=>{
        setIsOpen(false)
        if(!userOnboarding?.users?.section_completed && userOnboarding?.users?.step_completed_count <= 4 && !userData?.is_super_admin){
            if(userOnboarding?.users?.step_completed_count === 3){
                dispatch(
                    updateUserOnboarding({
                        onboarding_step: {
                            step_completed_count: 3,
                            section_completed: false,
                            section: 'users'
                        }
                    })
                );
            }
            setTimeout(()=>{
                if(window.location.pathname?.includes("users"))
                    setIsOpen(true)
            },1000)
            setSteps(usersTourSteps(navigate))
            setCurrentStep(4)
            setMeta('users')
        } 
    },[])

    return(
        <section id="usersScreen">
            <div className='d-flex align-items-center justify-content-between'>
                <Link to={location?.state?.from || "/users"} onClick={checkIsSaved}>
                    <img src={arrow_left} />
                    {t.buttons.back}
                </Link>
            </div>
            <div className='mt-3 users-step-4'>
                <div className='d-flex align-items-center '>
                    <img src={settings_img} className='me-2'/>
                    <h1>{t.users.settings.users_settings}</h1>
                </div>
                <Tabs
                    defaultActiveKey="auth"
                    id="noanim-tab-example"
                    className="mt-3 mb-4"
                >
                    <Tab eventKey="auth" title={t.users.settings.auth}>
                        <p>{t.users.settings.auth_text}</p>
                        <ContentCard>
                            <h2>{t.users.settings.auth_method}</h2>
                            <Form>
                                <div className='mt-3'>
                                    <Form.Check
                                        inline
                                        label={t.users.settings.auto_check}
                                        name="authType"
                                        type={'radio'}
                                        id="auto"
                                        checked={!userAuthSettings?.additional_auth_check || false}
                                        onChange={()=>{setIsUpdated(true);setUserAuthSettings({...userAuthSettings, additional_auth_check: false})}}
                                    />
                                    <Form.Check
                                        inline
                                        label={t.users.settings.manual_check}
                                        name="authType"
                                        type={'radio'}
                                        id="manual"
                                        checked={userAuthSettings?.additional_auth_check || false}
                                        onChange={()=>{setIsUpdated(true);setUserAuthSettings({...userAuthSettings, additional_auth_check: true})}}
                                    />
                                </div>
                            </Form>
                        </ContentCard>
                        { userAuthSettings?.additional_auth_check ?
                        <ContentCard className="mt-4">
                            <h2>{t.users.settings.domains}</h2>
                            <Form>
                                <TagsInput inputProps={{placeholder: t.users.settings.add_domain}} label={t.users.settings.add_domain} value={userAuthSettings?.automatic_domain_auth || []} onChange={(e)=>{setIsUpdated(true);setUserAuthSettings({...userAuthSettings, automatic_domain_auth: e})}} />
                            </Form>
                        </ContentCard> : null}
                        <footer className='control-footer'>
                            <div className='d-flex justify-content-end'>
                                <button disabled={!isUpdated} onClick={handleSaveAuthSettings}>
                                    {t.buttons.edit_save}
                                </button>
                            </div>
                        </footer>
                    </Tab>
                    <Tab eventKey="data" title={t.users.settings.data}>
                        <div className='d-flex justify-content-end'>
                            <button onClick={()=>addField()}>
                                + {t.users.settings.add_field}
                            </button>
                        </div>
                        <div className='fieldsType'>
                            {FIED_TYPES.map((f,k)=>{
                                if(!userProfileFields.find(_f => f.field_id && _f.field_id === f.field_id)){
                                    return(
                                        <div key={k} className='field_type' onClick={()=>addField(f)}>
                                            <h5>{f?.field_names?.it ? f?.field_names?.it : t.users.settings.fields[f.field_type]}</h5>
                                            { f.field_type === "text" ? <p>Testo della risposta...</p> : ""}
                                            { f.field_type === "datetime" ? <p>Giorno, mese, anno</p> : ""}
                                            { f.field_type === "singular" ? <><input type='radio'  /> <label>Opzione 1</label></> : ""}
                                            { f.field_type === "multiple" ? <><input type='checkbox'  /> <label>Opzione 1</label></> : ""}
                                        </div>
                                    )
                                } else return ''
                            })}
                        </div>
                        <div className='fieldList mt-4'>
                            <h5>{t.users.settings.fields.fields} <strong>({userProfileFields?.length})</strong></h5>
                            <DragDropContext onDragEnd={dragEnded}>
                                <Droppable droppableId="fields-wrapper">
                                    {(provided, snapshot) => (
                                        <DraggableFields ref={provided.innerRef} {...provided.droppableProps}>
                                        {userProfileFields.map((f,k)=>{
                                            return (
                                                <div key={k}>
                                                {f.is_open ?
                                                    <div className='d-flex justify-content-end mb-2'>
                                                        <div className='d-flex align-items-center pe-3'>
                                                            { !DEFAULT_FIELDS.includes(f.field_id) ?
                                                            <div className='d-flex align-items-center pe-3 border-end border-2 pointer' onClick={()=>handleDuplicateField(f)}>
                                                                <img src={copy_img} />
                                                                <span className='ms-1 fw-bold'>{t.actions.duplicate}</span>
                                                            </div> : null}
                                                            <div className='d-flex align-items-center ps-3 pointer' onClick={()=>handleRemoveField(k)}>
                                                                <img src={trash_img} />
                                                                <span className='ms-1 fw-bold'>{t.actions.delete}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                : null}
                                                <Draggable
                                                draggableId={`field-${k}`}
                                                index={k}
                                                key={`${k}`}
                                                >
                                                    {(_provided, _snapshot) => (
                                                        <DraggableFieldCard 
                                                            ref={_provided.innerRef}
                                                            dragHandleProps={_provided.dragHandleProps}
                                                            {..._provided.draggableProps}
                                                            snapshot={_snapshot}
                                                            t={t} f={f} k={k} handleUpdateField={handleUpdateField}
                                                        />
                                                    )}
                                                </Draggable>
                                                </div>
                                            )
                                        })}
                                        {provided.placeholder}
                                    </DraggableFields>
                                )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                        <footer className='control-footer'>
                            <div className='d-flex justify-content-end'>
                                <button disabled={!isUpdated} onClick={handleSaveProfileFields}>
                                    {t.buttons.edit_save}
                                </button>
                            </div>
                        </footer>
                    </Tab>
                </Tabs>
            </div>
            <ConfirmModal props={confirmModal}/>
        </section>
        
    )
}